
<template>
    <div>
<h3>{{principal}}</h3> 

    <v-card>
      <v-toolbar flat color="primary" dark>
        <v-toolbar-title>Registro de Principals</v-toolbar-title>
      </v-toolbar>
      <v-tabs v-model="tab">
       
       <v-tab href="#one">
          <v-icon left>mdi-account</v-icon>
          Registro
        </v-tab>
        
        <v-tab href="#two" >
          <v-icon left>mdi-dns</v-icon>
          Listado
        </v-tab>
    </v-tabs>
         <v-tabs-items :value="tab"> 
          <!-- <div :value="tab"> -->
        <v-tab-item value="one">
          <v-card flat>
            <v-card-text>
               <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >
   
   
    <v-text-field
           v-model="principal.nombre"
           label="Nombre"
           :counter="3"
           :rules="textRules"
           required
         ></v-text-field>
   
   
    <v-text-field
           v-model="principal.apellido"
           label="Apellido"
           :counter="3"
           :rules="textRules"
           required
         ></v-text-field>
   
   
    <v-text-field
           v-model="principal.descripcion"
           label="Descripcion"
           :counter="3"
           :rules="textRules"
           required
         ></v-text-field>
   
   
    <v-text-field
           v-model="principal.linkPhoto"
           label="LinkPhoto"
           :counter="3"
           :rules="textRules"
           required
         ></v-text-field>

      
   
   
    <v-text-field
           v-model="principal.observacion"
           label="Observacion"
           :counter="3"
           :rules="textRules"
           required
         ></v-text-field>
   
   
    <v-text-field
           v-model="principal.linkVideo"
           label="LinkVideo"
           :counter="3"
           :rules="textRules"
           required
         ></v-text-field>
   
   
   

 <v-row no-gutters>
      
      <v-col>
      </v-col>

      <v-col order="last">
        
      </v-col>
     
    </v-row>


      
      <v-btn
        :disabled="!valid"
        color="success"
        class="mr-4"
        @click="registrar"
      >
        Registrar
      </v-btn>

      <v-btn
        color="error"
        class="mr-4"
        @click="reset();"
      >
        Cancelar
      </v-btn>
  
    </v-form> 
            </v-card-text>


           <v-card-text>

            <v-alert
      border="top"
      colored-border
      type="info"
      elevation="2"
      
    >
      El presente registro es responsable de almacenar información sobre el Principal.<br>
      
    </v-alert>

          </v-card-text>




          </v-card>
        </v-tab-item>

   <!--  fin item 1-->
<v-tab-item value="two">
          <v-card flat>
            <v-card-text>

<v-text-field
            v-model="buscador" 
            placeholder="Ejemplo: Juan Perez"
            outlined
           
          >
          <template v-slot:label>
          <v-icon style="vertical-align: middle">
            mdi-magnify
          </v-icon>
          Busqueda por nombre de Principal
        </template>
          
          
          </v-text-field>



             
 <v-simple-table fixed-header>
    <template v-slot:default>


      <thead class="thead-dark">
        <tr>    
			
		<th scope="col">Id</th>
		<th scope="col">Nombre y Apellido</th>
		<!-- <th scope="col">Apellido</th> -->
    <th scope="col">Identificador</th>
    <th scope="col">Estado</th>
     <th scope="col">Verificado?</th>
    <!-- <th scope="col">Correo</th>
		<th scope="col">Descripcion</th>
		<th scope="col">LinkPhoto</th>
		<th scope="col">Observacion</th> -->
		<!-- <th scope="col">LinkVideo</th>
    <th scope="col">Agregar Enlaces</th>
		        <th scope="col">Editar</th>
		          <th scope="col">Eliminar</th> -->
        </tr>
      </thead>
      <tbody>
        <tr v-for="principal in principalsBuscados" :key="principal.codigo">       
<td>{{principal.id}}</td>


<td>{{principal.nombre}} {{principal.apellido}}</td>


<!-- <td>{{principal.apellido}}</td> -->

<td>{{principal.identificador}}</td>
<!-- Email esta asociado con usuario -->
<!-- <td>{{principal.email}}</td>


<td>{{principal.descripcion}}</td>


<td>{{principal.linkPhoto}}</td>


<td>{{principal.observacion}}</td> -->

<td :class="estadoClase(principal.estado)">{{principal.estado}}</td>
<td><v-switch
              v-model="principal.verified"
               label="Habilitar"
               @click="habilitar(principal)"
                ></v-switch></td>


<!-- <td>{{principal.linkVideo}}</td>

<td>
  
        <PrincipalOpcion 
        class="pa-2"
        outlined
        tile
         :principalData="principal"
         @seleccionarPrincipalOpcion="recibirPrincipalOpcion">     </PrincipalOpcion>

</td>




  <td>
              <principal-dialog :principalData="principal"   @principalEdit="recibirPrincipal"></principal-dialog>
              
            </td>
        
            <td>
              <button @click="eliminarPrincipal(principal)" class="btn"><v-icon left>mdi-delete-forever</v-icon></button>
            </td> -->
     
 </tr>
      </tbody>
    </template>
  </v-simple-table>

            </v-card-text>
          </v-card>
        </v-tab-item>

        <!--  fin item 2-->
     

      </v-tabs-items> 

          <!-- </div> -->
    </v-card>
  </div>
</template>


<script>
import principalService from "@/services/principalService.js";

import axios from 'axios';

import PrincipalDialog from '../principal/PrincipalDialog';

import PrincipalOpcion from '../principal/PrincipalOpcionDialog.vue';



export default {
     name: 'Principal',
    
  components: {
   PrincipalDialog,
   PrincipalOpcion
  },
  computed: {
    tab: {
      set (tab) {
        this.$router.replace({ query: { ...this.$route.query, tab } })
      },
      get () {
        return this.$route.query.tab
      }
    }
  },
    data: vm => ({
    valid: true,
    tab:"",
    buscador:'',
showPass: false,
  principals: [],
        principal:{

id:'',
nombre:'',
apellido:'',
descripcion:'',
linkPhoto:'',
observacion:'',
linkVideo:'',

          
        },









        rules: {
                  required: value => !!value || 'Campo Requerido',
                  min: v => v.length >= 5 || 'Minimo 5 caracteres',
                  emailMatch: () => (`The email and password you entered don't match`),
                },
        	messages:undefined,
        
        
        
         textRules: [
              (v) => !!v || "Campo es requerido",
              (v) => (v && v.length >= 3) || "Debe contener al menos 3 caracteres",
            ],
        
        
        
        
        
        
    
  }),
  created(){

       }
  ,mounted(){
      this.listarPrincipals();
    
      this.tab="two";

   
    },

  methods: {
    listarPrincipals() {
      principalService
        .listarPrincipals()
        .then((resposta) => {
      //    console.log(resposta.data);
          this.principals = resposta.data;
        })
  
  },
    registrar(){
    if (this.$refs.form.validate()) {
   
          if(this.principal.codigo===""||this.principal.codigo===null){
      //Eliminar para que funcione el auto incrementable
        delete this.principal.codigo;
          }

        console.log(this.principal);

          principalService.save(this.principal,this.config).then(resposta=>{
           this.limpiar();
              alert('Guardado exitoso!!')
              this.listarPrincipals();
               this.selectedTab="second";
          });


        
      }
    },
    editarPrincipal(principal){

    //  console.log('Editar Principal');
      
     //
     // console.log(this.principal);


     this.principal.id=principal.id;
     this.principal.id=principal.id;
     this.principal.nombre=principal.nombre;
     this.principal.apellido=principal.apellido;
     this.principal.descripcion=principal.descripcion;
     this.principal.linkPhoto=principal.linkPhoto;
     this.principal.observacion=principal.observacion;
     this.principal.linkVideo=principal.linkVideo;
     

      this.tab="one";
  
       console.log(principal);

    },
    eliminarPrincipal(principal){

        if(confirm('Desea remover al principal')){
        
        principalService.delete(principal).then(resposta=>{
          this.listarPrincipals();
          this.errors=[]
          this.limpiar();

        }).catch(e=>{

          this.errors =e.response.data.errors

        })

        }


        


    },
    limpiar(){

     
		this.principal={
				id:'',
				id:0,
				nombre:'',
				apellido:'',
				descripcion:'',
				linkPhoto:'',
				observacion:'',
				linkVideo:'',
	}

        
    },
  recibirPrincipal:function(principal){

      console.log('En elemento padre Redact despues de editar');
      //  console.log(principal);
 
    },
		
    validate () {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
      }
    },
    reset() {
    //  this.$refs.form.reset();
      this.limpiar();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    recibirPrincipalOpcion:function(principalOpcion){

      console.log('En elemento padre Principal');
      //  console.log(principalOpcion);
     

    },
    habilitar(principal){


      principalService.verificarPrincipal(principal).then(
        response =>{
           
            console.log(response.data);
          
        }).catch((errors) =>{
           console.log('error');
            console.log(errors);

           
        })

    },
     estadoClase(estado) {
    if (estado === null || estado === 'disabled') {
      return 'grey--text text--darken-1 grey lighten-4'; // texto gris + fondo gris
    }

    switch (estado) {
      case 'required':
        return 'orange--text text--darken-2 orange lighten-4'; // texto naranja + fondo claro
      case 'public':
        return 'green--text text--darken-2 green lighten-4'; // texto verde + fondo claro
      default:
        return '';
    }
  }
  
  },

    watch: {
      
    },
  computed:{
    


    	
    principalsBuscados() {
          return this.principals.filter(principal => {
            return principal.nombre.toLowerCase().includes(this.buscador.toLowerCase());
          });
    
      }
    
  
  },
};
</script>




